import {
  LanguageDTO,
  NotificationSettings,
  getLanguageList,
  getNotificationSettings,
  setNotificationSetting,
  setPreferredLanguage,
} from '@/apis/settingApis'
import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react'

export const settingApiSlice = createApi({
  reducerPath: 'languageApi',
  baseQuery: fakeBaseQuery(),
  tagTypes: ['GetLanguage', 'Notification'],

  endpoints: (builder) => ({
    getLanguageList: builder.query<any, void>({
      queryFn: async (data) => {
        try {
          return await getLanguageList()
        } catch (error) {
          throw new Error((error as any).response.data.message)
        }
      },
      providesTags: ['GetLanguage'],
    }),
    setPreferredLanguage: builder.mutation<{ data: LanguageDTO }, LanguageDTO>({
      queryFn: async (data) => {
        try {
          return await setPreferredLanguage(data)
        } catch (error) {
          throw new Error((error as any).response.data.message)
        }
      },
      invalidatesTags: ['GetLanguage'],
    }),
    getNotificationSetting: builder.query<NotificationSettings, void>({
      queryFn: async (data) => {
        try {
          return await getNotificationSettings()
        } catch (error) {
          throw new Error((error as any).response.data.message)
        }
      },
      providesTags: ['Notification'],
    }),
    setNotifciationSetting: builder.mutation<
      { data: NotificationSettings },
      Partial<NotificationSettings>
    >({
      queryFn: async (data) => {
        try {
          return await setNotificationSetting(data)
        } catch (error) {
          throw new Error((error as any).response.data.message)
        }
      },
      invalidatesTags: ['Notification'],
    }),
  }),
})

export const {
  useGetLanguageListQuery,
  useSetPreferredLanguageMutation,
  useGetNotificationSettingQuery,
  useSetNotifciationSettingMutation,
} = settingApiSlice

export const resetSettingApiSlice = () => settingApiSlice.util.resetApiState()

export const invalidateSettingApiSlice = settingApiSlice.util.invalidateTags
